import superagent from 'superagent';

import { getCsrfToken, isValidValue } from '../util/pure_functions/utils';

export function wrapResolveReject(resolve, reject) {
  return (err, res) => {
    if(err && err.status != 403) {
      var error = new Error("API Call Failed");
      error.err = err;
      error.res = res;
      reject(error);
    } else {
      if (err != 403) {
	resolve(res.body);
      }
    }
  }
}

export function wrapResolveRejectWithHeaders(resolve, reject) {
  return (err, res) => {
    if(err) {
      var error = new Error("API Call Failed");
      error.err = err;
      error.res = res;
      reject(error);
    } else {
      resolve(res);
    }
  }
}

export function getPromise(url, params) {
  return new Promise((resolve, reject) => {
    superagent.get(url).query(params).end(wrapResolveReject(resolve, reject));
  });
}

export function postPromise(url, body) {
  return new Promise((resolve, reject) => {
    superagent.post(url).send(body)
    .set('X-CSRF-Token', getCsrfToken())
    .end(wrapResolveReject(resolve, reject));
  });
}

export function postForm(url, body) {
  return new Promise((resolve, reject) => {
    superagent.post(url)
      .type('form')
      .send(body)
      .set('X-CSRF-Token', getCsrfToken())
      .end(wrapResolveReject(resolve, reject));
  });
}

export function putPromise(url, body) {
  return new Promise((resolve, reject) => {
    superagent.put(url)
    .send(body)
    .set('X-CSRF-Token', getCsrfToken())
    .end(wrapResolveReject(resolve, reject));
  });
}

export function deletePromise(url, params = {}) {
  return new Promise((resolve, reject) => {
    superagent
    .delete(url)
    .send(params)
    .set('X-CSRF-Token', getCsrfToken())
    .end(wrapResolveReject(resolve, reject));
  });
}



// WEBPACK FOOTER //
// ./app/javascript/gateway/request.js